import React, { ReactElement, SyntheticEvent, useState } from 'react';
import { SCRootWrapper } from './styles';
import { ITSBackNavigationProps } from './types';
import { TSButton } from 'components/atoms/TSButton';
import { TSButtonSizeEnum, TSButtonVariantsEnum } from 'enums/TSButtonVariants';
import { ClaimTypesEnum, TimelineState } from 'enums';
import { ClaimStateEnum } from 'enums/ClaimState';
import {
    $digitalBlack,
    SCContentSectionResponsiveWrapper,
    SCContentSectionWrapper,
    SCSectionBody,
    SCSectionSubHead
} from 'styles/global-styles';
import { FlexAlignItemsEnum, FlexDirectionEnum, FlexJustifyContentEnum } from 'enums/StyleTypes';
import { TSDialog } from 'components/atoms/TSDialog';
import { ClaimOptionContext, IClaimOptionTypeState } from 'context/ClaimOption';
import { ClaimProgressJobLossContext, IClaimProgressJobLossTypeState } from 'context/ClaimProgressJobLoss';
import { ClaimProgressDisabilityContext, IClaimProgressDisabilityTypeState } from 'context/ClaimProgressDisability';

const TSBackNavigation = ({ isFormDirty }: ITSBackNavigationProps): ReactElement => {
    const {
        updateContextStateClaimProgressJobLoss,
        contextStateClaimProgressJobLoss,
        resetContextStateClaimProgressJobLoss,
        updateClaimProgressJobLossCompletionStatus,
        claimProgressJobLossCompletionStatus,
        updateAllClaimProgressJobLossCompletionStatus
    } = React.useContext(ClaimProgressJobLossContext) as IClaimProgressJobLossTypeState;
    const {
        contextStateClaimProgressDisability,
        updateContextStateClaimProgressDisability,
        resetContextStateClaimProgressDisability,
        claimProgressDisabilityCompletionStatus,
        updateClaimProgressDisabilityCompletionStatus,
        updateAllClaimProgressDisabilityCompletionStatus
    } = React.useContext(ClaimProgressDisabilityContext) as IClaimProgressDisabilityTypeState;
    const { contextStateClaimOption, updateContextStateClaimOption } = React.useContext(
        ClaimOptionContext
    ) as IClaimOptionTypeState;
    const [confirmModalIsVisible, setConfirmModalIsVisible] = useState(false);
    const currentId =
        contextStateClaimOption.type === ClaimTypesEnum.Jobloss
            ? contextStateClaimProgressJobLoss
                  .filter((item): boolean => item.status === TimelineState.ACTIVE)
                  .map((item) => item.id)
            : contextStateClaimProgressDisability
                  .filter((item): boolean => item.status === TimelineState.ACTIVE)
                  .map((item) => item.id);
    const decrementId = currentId[0]
        ? currentId[0].replace(/\d+$/, (n): string => {
              return (parseInt(n) - 1) as unknown as string;
          })
        : '';
    const handleBackFormStates = (): void => {
        if (currentId[0] === 'id-1') {
            updateContextStateClaimOption({
                type: undefined,
                reviewState: ClaimStateEnum.ACTIVE
            });
            updateContextStateClaimProgressJobLoss(currentId[0], TimelineState.COMPLETE);
            updateContextStateClaimProgressDisability(currentId[0], TimelineState.COMPLETE);
            setConfirmModalIsVisible(true);
        }
        if (contextStateClaimOption.type === ClaimTypesEnum.Jobloss) {
            updateContextStateClaimProgressJobLoss(decrementId, TimelineState.ACTIVE);
            updateContextStateClaimProgressJobLoss(currentId[0], TimelineState.COMPLETE);
        } else if (contextStateClaimOption.type === ClaimTypesEnum.Disability) {
            updateContextStateClaimProgressDisability(decrementId, TimelineState.ACTIVE);
            updateContextStateClaimProgressDisability(currentId[0], TimelineState.COMPLETE);
        }
    };
    /*
    console.info(
        '\n::::::::::::::::::::::::::::::::TSBackNavigation:::::::::::::::::::::::::::::::::',
        '\n::currentId::',
        currentId,
        '\n::decrementId::',
        decrementId,
        '\n::contextStateClaimProgressJobLoss::',
        contextStateClaimProgressJobLoss,
        '\n::contextStateClaimProgressDisability::',
        contextStateClaimProgressDisability,
        '\n::isFormDirty::',
        isFormDirty,
        '\n:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
    );
    */

    return (
        <>
            <SCRootWrapper>
                <TSButton
                    tsVariant={TSButtonVariantsEnum.BACK}
                    ariaLabel={'button for saving table changes'}
                    onClick={(event: SyntheticEvent<Element, Event>): void => {
                        isFormDirty && currentId[0] === 'id-1'
                            ? setConfirmModalIsVisible(true)
                            : handleBackFormStates();
                    }}
                >
                    Back
                </TSButton>
            </SCRootWrapper>
            <TSDialog
                ariaLabel={'Unsaved Changes dialog'}
                hideSecondaryCloseButton
                handleClose={(): void => {
                    setConfirmModalIsVisible(false);
                }}
                id={'unsavedChangesDialog'}
                open={confirmModalIsVisible}
                dialogSize={'sm'}
                bannerHeaderCloseButtonText={'Close'}
                content={
                    <SCContentSectionWrapper
                        flexDirection={FlexDirectionEnum.COLUMN}
                        flexAlignment={FlexAlignItemsEnum.FLEX_START}
                        flexGap={'24px'}
                    >
                        <SCSectionSubHead textColor={$digitalBlack}>Unsaved Changes</SCSectionSubHead>
                        <SCSectionBody>
                            You have unsaved claim information, continuing may cause your information to be lost
                        </SCSectionBody>
                    </SCContentSectionWrapper>
                }
                actionChildren={
                    <SCContentSectionResponsiveWrapper
                        flexJustifyContent={FlexJustifyContentEnum.SPACE_AROUND}
                        flexAlignment={FlexAlignItemsEnum.CENTER}
                        flexDirection={FlexDirectionEnum.COLUMN}
                        flexGap={'16px'}
                    >
                        <TSButton
                            ariaLabel="dialog return to page"
                            tsVariant={TSButtonVariantsEnum.TEXT}
                            size={TSButtonSizeEnum.MEDIUM}
                            onClick={(): void => {
                                setConfirmModalIsVisible(false);
                            }}
                        >
                            Return to page
                        </TSButton>
                        <TSButton
                            ariaLabel="dialog proceed without saving"
                            tsVariant={TSButtonVariantsEnum.ARROW}
                            size={TSButtonSizeEnum.MEDIUM}
                            onClick={(): void => {
                                handleBackFormStates();
                                setConfirmModalIsVisible(false);
                            }}
                        >
                            Proceed without saving
                        </TSButton>
                    </SCContentSectionResponsiveWrapper>
                }
            ></TSDialog>
        </>
    );
};

export { TSBackNavigation };
